import PropTypes from 'prop-types'
import { forwardRef } from 'react'
// @mui
import { Box } from '@mui/material'

// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, sx, ...other }, ref) => {
  const logo = (
    <Box
      ref={ref}
      component="div"
      sx={{
        width: 40,
        height: 40,
        display: 'inline-flex',
        ...sx,
      }}
      {...other}
    >
      <img src="/fdc-icon.png" alt="FDC logo" />
    </Box>
  )

  if (disabledLink) {
    return <>{logo}</>
  }

  return <Box sx={{ display: 'contents' }}>{logo}</Box>
})

Logo.propTypes = {
  sx: PropTypes.object,
  disabledLink: PropTypes.bool,
}

Logo.displayName = 'Logo'

export default Logo
